import React from "react";
import { Col, Row } from "react-bootstrap";
import { UserProfile, ActionHandlerFunction } from "@preveil-api";
import { ApproversRow } from ".";

type AllProps = {
  approvers: UserProfile[];
  current_users_approved: UserProfile[];
  handleAction: ActionHandlerFunction;
  required_approvers?: number;
}

// Description: Panel showing the approvers and their approval status
function ApproversPanelComponent(props: AllProps) {
  const { approvers, current_users_approved, handleAction, required_approvers } = props;
  const users_approved_total = current_users_approved && current_users_approved.length;

  return <>
    <h3>{`You've received ${users_approved_total} of ${required_approvers} required approvals`}</h3>
    <div className="approvers-panel">
      <Row className="header-row">
        <Col>Approvers</Col>
      </Row>
      {approvers.map((approver: UserProfile) => {
        const is_approved = current_users_approved.length > 0 ? current_users_approved.find((user: UserProfile) => user.address === approver.address) : undefined;
        const is_read_only = required_approvers === current_users_approved.length && !is_approved;
        return <ApproversRow key={approver.address} user={approver} is_approved={!!is_approved} handleAction={handleAction} is_read_only={is_read_only} />;
      })}
    </div>
  </>;
}

export default React.memo(ApproversPanelComponent);